<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Site Lock/Unlock
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <label class="Label">Branch <span class="text-danger">*</span></label>
                <ng-select name="branch" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="Filter.BranchId" (change)="ComboLoad('Client');clear()" placeholder="Select Branch">

                    <ng-template ng-option-tmp let-item="item">
                        <span [ngbTooltip]="item.BranchName" container="body" placement="right">{{ item.BranchName
                            }}</span>
                    </ng-template>
                </ng-select>
            </div>

            <div class="col-md-6">
                <label class="Label">Client</label>
                <ng-select name="client" [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                    [(ngModel)]="Filter.ClientId" placeholder="Select Client" (change)="clear()">

                    <ng-template ng-option-tmp let-item="item">
                        <span [ngbTooltip]="item.ClientGroupName" container="body" placement="auto">{{
                            item.ClientGroupName
                            }}</span>
                    </ng-template>
                </ng-select>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-auto">
                <label for="FromDateObj" class="Label"> Month Year </label>
                <div class="input-group">
                    <ngb-datepicker #dp name="monthyear" [(ngModel)]="Filter.MonthName"
                        class="month-year small-datepicker"  (ngModelChange)="clear()"
                        (navigate)="Filter.MonthName= $event.next;onNavigate($event)"></ngb-datepicker>
                </div>
            </div>

            <!-- <div class="col-md-auto align-self-center mt-3">
                <label for="sitefor" class="form-label text-label-dark">Site For :</label>
            </div>
            <div class="col-md-4 mt-4">
                <div class="btn-group btn-group-toggle">
                    <label class="form-check-label link-dark px-1 form-label" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value="1" name="sitefor"
                            [(ngModel)]="Filter.SiteFor" [ngModelOptions]="{standalone: true}">
                        Lock
                    </label>
                    <label class="form-check-label link-dark px-1 form-label" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value="2" name="sitefor"
                            [(ngModel)]="Filter.SiteFor" [ngModelOptions]="{standalone: true}">
                        Unlock
                    </label>
                </div>
            </div> -->

            <div class="col-md-3 mt-1">
                <div class="card p-1 shadow-sm">
                    <label class="Label">Get Site For</label>

                    <!-- Radio buttons in single line -->
                    <div class="d-flex flex-wrap gap-3 pt-2 mb-0">
                        <div class="btn-group btn-group-toggle mb-0">
                            <label class="form-check-label link-dark px-1 me-2 form-label mb-0" ngbButtonLabel>
                                <input class="form-check-input" type="radio" value="1" name="sitefor"
                                    [(ngModel)]="Filter.SiteFor" (ngModelChange)="clear()" [ngModelOptions]="{standalone: true}">
                                🔒 Lock
                            </label>
                            <label class="form-check-label link-dark px-1 form-label mb-0" ngbButtonLabel>
                                <input class="form-check-input" type="radio" value="2" name="sitefor"
                                    [(ngModel)]="Filter.SiteFor" (ngModelChange)="clear()" [ngModelOptions]="{standalone: true}">
                                🔓 Unlock
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto pt-4">
                <button (click)="GetSites()" type="submit" class="upload-btn" [disabled]="isDisabled">
                    <!-- <i class="bi bi-gear" *ngIf="!isDisabled"></i> -->
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Get Sites':'Loading...'}}
                </button>
            </div>
        </div>

        
        <hr>
        <div class="mt-4">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead>
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th scope="col" style="width: 5px;">
                            <div style="width:75px"><input class="form-check-input" type="checkbox" id="IsCheckAll"
                                    name="IsCheckAll" (click)="CheckAll($event)"> Check All

                            </div>
                        </th>
                        <th scope="col">Branch</th>
                        <th scope="col">Client</th>
                        <th scope="col">SiteName</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="font-size: 12px;" *ngFor="let data of TableData; let i = index">
                        <td style="width: 5px;" style="text-align: center;">
                            {{i+1}}
                        </td>
                        <td style="width: 5px;" class="text-center">
                            <div style="width: 80px;"><input class="form-check-input" type="checkbox"
                                    id="check{{i}}" name="check{{i}}" [(ngModel)]="TableData[i]['checked']">
                            </div>
                        </td>

                        <td>{{data['BranchName']}}</td>
                        <td>{{data['ClientGroupName']}}</td>
                        <td>{{data['SiteCode']}} - {{data['SiteName']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="Save()" type="submit" class="upload-btn" [disabled]="isDisabled">
                    <!-- <i class="bi bi-gear" *ngIf="!isDisabled"></i> -->
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}} <i class="bi bi-box-arrow-in-down"></i>
                </button>
            </div>
        </div>
    </div>
</div>